import * as React from "react";

import { PipelineProgress as Progress } from "@/types/contract-family-pipeline";

export const PipelineProgress = ({
  progress,
  label,
  attemptId,
}: {
  progress: Progress;
  label: string;
  attemptId?: string | null;
}) => {
  const displayed = React.useRef({ attemptId, value: progress.progress });
  if (displayed.current.attemptId !== attemptId) displayed.current = { attemptId, value: progress.progress };
  else displayed.current.value = Math.max(displayed.current.value, progress.progress);
  const percentage = displayed.current.value * 100;
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(percentage)}
      className="space-y-2"
    >
      <p className="text-sm font-medium">
        {progress.completed} of {progress.total} completed
      </p>
      <div className="h-2 overflow-hidden rounded-full bg-slate-100">
        <div className="h-full bg-coral" style={{ width: `${percentage}%` }} />
      </div>
      <p className="text-xs text-slate-500">
        {progress.processing} processing · {progress.failed} failed · {progress.skipped} skipped
      </p>
    </div>
  );
};
